import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { LoginValue } from "./LoginPageAction";
import { connectMQTT, subscribeMQTT } from "./mqttActions";

// Action types
export const AUTH_START = "AUTH_START";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_FAILURE = "AUTH_FAILURE";
export const SET_MFA_REQUIRED = "SET_MFA_REQUIRED";

// Thunk
export const loginUser =
  (formData, getDeviceId, navigate) => async (dispatch) => {
    dispatch({ type: AUTH_START });
    try {
      const deviceId = await getDeviceId();

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/users/authenticate`,
        {
          email: formData.username,
          passKey: formData.password,
          deviceId,
        },
        { headers: { "Content-Type": "application/json" } }
      );

      const token = response.data?.token;
      const decodedToken = jwtDecode(token);
      const user = response.data?.user;

      localStorage.setItem("token", JSON.stringify(token));
      if (user.rememberDeviceCheck || decodedToken.mfa_enabled === "0") {
        localStorage.setItem("isMFACompleted", "true");
        localStorage.setItem("isAuthenticated", "true");
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/global/getAllListGlobalAppSetting`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        const fetchedSettings = {};

        response.data.allGlobalSettings.forEach((item) => {
          fetchedSettings[item.code] = item.value;
        });
        if (
          fetchedSettings.isValidated === "0" &&
          decodedToken.userRole === "SUPER_ADMIN"
        ) {
          localStorage.setItem("lastPath", "/onboarding-with-license");
          navigate("/onboarding-with-license");
        } else {
          localStorage.setItem("lastPath", "/dashboard");
        }
        dispatch(LoginValue(true));
        dispatch({ type: AUTH_SUCCESS, payload: token });

        // MQTT Connection
        dispatch(connectMQTT());
        dispatch(subscribeMQTT("sensor/data", (topic, msg) => {}));
      } else {
        dispatch({ type: SET_MFA_REQUIRED });
      }
    } catch (error) {
      //console.error("Login error:", error);
      dispatch({ type: AUTH_FAILURE, payload: "Invalid credentials" });
    }
  };
